/**
 * Created by Alican Köker on 2019-03-14.
 */
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";

export class EdisonFreespinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super(config, tweakEnabled);
    }
}